import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Container,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

function generateRandomState() {
  const array = new Uint32Array(8);
  window.crypto.getRandomValues(array);
  return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join(
    ""
  );
}

const DesktopAuthWait = () => {
  const history = useHistory();
  const theme = useTheme();

  useEffect(() => {
    // Listen for the auth:done event
    const removeListener = window.electron.ipcRenderer.on(
      "auth:done",
      (data) => {
        if (data.success) {
          window.location.href = "/";
        } else {
          history.replace("/user-login");
        }
      }
    );

    // Clean up listeners when component unmounts
    return () => {
      removeListener();
    };
  }, [history]);

  const handleResendAuthRequest = () => {
    const code = generateRandomState();
    // Use Electron's shell to open in default browser
    window.electron.ipcRenderer.send(
      "open-external-url",
      `${window.location.origin}/desktop-login?id=${code}`
    );
    window.electron.ipcRenderer.send("start-auth-polling", code);
    // Navigate to the waiting page
    history.push("/desktop-auth-wait");
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            width: "100%",
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            bgcolor: "background.paper",
            boxShadow: "none",
          }}
        >
          <Box
            component="img"
            src="/logo192.png"
            alt="Company Logo"
            sx={{
              maxWidth: "64px",
              width: "100%",
              height: "auto",
              mb: 3,
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom>
            Waiting for Authorization
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Please complete the process in your browser.
          </Typography>

          <Box sx={{ position: "relative", display: "inline-flex", mb: 4 }}>
            <CircularProgress
              size={80}
              thickness={4}
              sx={{
                color: theme.palette.primary.main,
              }}
            />
          </Box>

          <Button
            variant="contained"
            onClick={handleResendAuthRequest}
            sx={{
              borderRadius: "50px",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            Send Auth Request Again
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default DesktopAuthWait;
